// 2022 Topps Chrome Star Wars The Mandalorian Beskar Edition — AUTHORED from
// the official Topps checklist PDF (CheckList_22SWMC_VERSION1.pdf), 2026-07-29.
// Released Aug 31, 2022 · 4 cards/pack · 18 packs/box · 12 boxes/case ·
// 1 autograph or sketch per box, 2 sketches per case.
// Parallels/print runs/odds: Cardboard Connection (all counts agree with the
// PDF: 100 base + 25 SP + 25 IC + 5 CC + 10 AR + 10 ML + 39 autos + 9 duals
// + 4 triples + 8 MLA = 235 cards + 2 generic sketch rows).
// Editorial notes (PDF-verbatim kept on purpose):
//   - S1-22 says "Episode 4" where every other card says "Chapter".
//   - S2-39 "AN UNLIKELY TEAM" all-caps; S2-40 "Saved by the…Empire?!".
//   - IC-19 "Luke Skywalker, Dark Tropper" (sic) and A-LS "Leilani SHIU" (sic).
//   - CC titles the 25-card IC insert "Concept Art"; the PDF's ILLUSTRATED
//     CHARACTERS wins.
//   - The PDF lists duals/triples one line per signer; rows here join the
//     signers per card code.
//   - Sketch roster never published (2 per case) — two generic rows, same
//     pattern as 2023 Chrome / 2023 Obi-Wan Kenobi.
//   - Legends Die-Cut Autographs are serial numbered but NO source publishes
//     the print run (CC: "Serial numbered", 1:12,751 packs) — no parallels
//     modeled rather than inventing a number.
// =============================================================================

export const SETS = [
  {
    id: 'base-cards',
    type: 'base',
    title: 'BASE CARDS',
    parallels: [
      { id: 'refractor', name: 'Refractor', print_run: null, color: '#c8d8f0' },
      { id: 'blue-refractor', name: 'Blue Refractor', print_run: 99, color: '#2979ff' },
      { id: 'purple-refractor', name: 'Purple Refractor', print_run: 75, color: '#b060ff' },
      { id: 'green-refractor', name: 'Green Refractor', print_run: 50, color: '#00e676' },
      { id: 'orange-refractor', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
      { id: 'black-refractor', name: 'Black Refractor', print_run: 10, color: '#b0b0b0' },
      { id: 'red-refractor', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'superfractor', name: 'SuperFractor', print_run: 1, color: '#f0c040' },
    ],
    cards: [
      {n:'S1-1', name:'Enter the Hunter', artist:'Chapter 1, Season 1'},
      {n:'S1-2', name:'Checking in with Greef Karga', artist:'Chapter 1, Season 1'},
      {n:'S1-3', name:'The Client', artist:'Chapter 1, Season 1'},
      {n:'S1-4', name:'The Mandalorian Foundling', artist:'Chapter 1, Season 1'},
      {n:'S1-5', name:'The Helpful Kuiil', artist:'Chapter 1, Season 1'},
      {n:'S1-6', name:'IG-11', artist:'Chapter 1, Season 1'},
      {n:'S1-7', name:'Crushing the Hunters', artist:'Chapter 2, Season 1'},
      {n:'S1-8', name:'Defending the Razor Crest', artist:'Chapter 2, Season 1'},
      {n:'S1-9', name:'Jawas on the Defensive', artist:'Chapter 2, Season 1'},
      {n:'S1-10', name:'Riding the Sandcrawler', artist:'Chapter 2, Season 1'},
      {n:'S1-11', name:'The Mudhorn Stopped!', artist:'Chapter 2, Season 1'},
      {n:'S1-12', name:'Handing over the Egg', artist:'Chapter 2, Season 1'},
      {n:'S1-13', name:'Delivering the "Asset"', artist:'Chapter 3, Season 1'},
      {n:'S1-14', name:'Paid in Beskar Steel', artist:'Chapter 3, Season 1'},
      {n:'S1-15', name:'Forging New Armor', artist:'Chapter 3, Season 1'},
      {n:'S1-16', name:'A Messy Infiltration', artist:'Chapter 3, Season 1'},
      {n:'S1-17', name:'Taking Grogu', artist:'Chapter 3, Season 1'},
      {n:'S1-18', name:'The Fight is on', artist:'Chapter 3, Season 1'},
      {n:'S1-19', name:'Reunited and Away!', artist:'Chapter 3, Season 1'},
      {n:'S1-20', name:'Village Under Siege', artist:'Chapter 4, Season 1'},
      {n:'S1-21', name:'Little Green Button Pusher', artist:'Chapter 4, Season 1'},
      {n:'S1-22', name:'The Scary Cat', artist:'Episode 4, Season 1'},
      {n:'S1-23', name:'The AT-ST has Awoken', artist:'Chapter 4, Season 1'},
      {n:'S1-24', name:'The Village Fights Back', artist:'Chapter 4, Season 1'},
      {n:'S1-25', name:'Grossing out the Kids', artist:'Chapter 4, Season 1'},
      {n:'S1-26', name:'Peli\'s New Job', artist:'Chapter 5, Season 1'},
      {n:'S1-27', name:'Tusken Raider Territory', artist:'Chapter 5, Season 1'},
      {n:'S1-28', name:'Bounty Bait', artist:'Chapter 5, Season 1'},
      {n:'S1-29', name:'The Plan For Fennec Shand', artist:'Chapter 5, Season 1'},
      {n:'S1-30', name:'Fennec Shand Captured', artist:'Chapter 5, Season 1'},
      {n:'S1-31', name:'Safe and Sound', artist:'Chapter 5, Season 1'},
      {n:'S1-32', name:'The Crew Assembled', artist:'Chapter 6, Season 1'},
      {n:'S1-33', name:'The Mandalorian\'s Secret Passenger', artist:'Chapter 6, Season 1'},
      {n:'S1-34', name:'Pure Firepower', artist:'Chapter 6, Season 1'},
      {n:'S1-35', name:'No Match for The Mandalorian', artist:'Chapter 6, Season 1'},
      {n:'S1-36', name:'Evasion Tactics', artist:'Chapter 6, Season 1'},
      {n:'S1-37', name:'The New Republic Closes in', artist:'Chapter 6, Season 1'},
      {n:'S1-38', name:'Recruiting Kuiil', artist:'Chapter 7, Season 1'},
      {n:'S1-39', name:'The Assassin Reborn', artist:'Chapter 7, Season 1'},
      {n:'S1-40', name:'Remote Rendezvous', artist:'Chapter 7, Season 1'},
      {n:'S1-41', name:'Greef Karga\'s Gift', artist:'Chapter 7, Season 1'},
      {n:'S1-42', name:'Moff Gideon\'s Arrival', artist:'Chapter 7, Season 1'},
      {n:'S1-43', name:'Kuiil and The Kid', artist:'Chapter 7, Season 1'},
      {n:'S1-44', name:'IG-11\'s Rescue', artist:'Chapter 8, Season 1'},
      {n:'S1-45', name:'An Uncertain Negotiation', artist:'Chapter 8, Season 1'},
      {n:'S1-46', name:'Showdown in the Streets of Nevarro', artist:'Chapter 8, Season 1'},
      {n:'S1-47', name:'Fate of the Mandalorians', artist:'Chapter 8, Season 1'},
      {n:'S1-48', name:'The Armorer Unleashed', artist:'Chapter 8, Season 1'},
      {n:'S1-49', name:'The Mandalorian Takes off', artist:'Chapter 8, Season 1'},
      {n:'S1-50', name:'Successful and Reunited', artist:'Chapter 8, Season 1'},
      {n:'S2-1', name:'The Meeting with Gor Koresh', artist:'Chapter 9, Season 2'},
      {n:'S2-2', name:'Back on Tatooine', artist:'Chapter 9, Season 2'},
      {n:'S2-3', name:'Cobb Vanth\'s Tale', artist:'Chapter 9, Season 2'},
      {n:'S2-4', name:'Taking Back Mos Pelgo', artist:'Chapter 9, Season 2'},
      {n:'S2-5', name:'Tension at the Tusken Camp', artist:'Chapter 9, Season 2'},
      {n:'S2-6', name:'The Mandalorian\'s Bold Move', artist:'Chapter 9, Season 2'},
      {n:'S2-7', name:'Return to Mos Eisley', artist:'Chapter 10, Season 2'},
      {n:'S2-8', name:'Peli\'s Sketchy lead', artist:'Chapter 10, Season 2'},
      {n:'S2-9', name:'Crashing Through the Ice', artist:'Chapter 10, Season 2'},
      {n:'S2-10', name:'Waking up the Beast', artist:'Chapter 10, Season 2'},
      {n:'S2-11', name:'The Ice Beast Returns', artist:'Chapter 10, Season 2'},
      {n:'S2-12', name:'Saved by the New Republic', artist:'Chapter 10, Season 2'},
      {n:'S2-13', name:'Dropping into Trask', artist:'Chapter 11, Season 2'},
      {n:'S2-14', name:'Sailing into the Trap', artist:'Chapter 11, Season 2'},
      {n:'S2-15', name:'An Unexpected Rescue', artist:'Chapter 11, Season 2'},
      {n:'S2-16', name:'Bo-Katan Revealed', artist:'Chapter 11, Season 2'},
      {n:'S2-17', name:'Storming the Imperial Cruiser', artist:'Chapter 11, Season 2'},
      {n:'S2-18', name:'In Search of the Darksaber', artist:'Chapter 11, Season 2'},
      {n:'S2-19', name:'The Child\'s New Friend', artist:'Chapter 11, Season 2'},
      {n:'S2-20', name:'Return to Nevarro', artist:'Chapter 12, Season 2'},
      {n:'S2-21', name:'A Daring Escape Plan', artist:'Chapter 12, Season 2'},
      {n:'S2-22', name:'Speeder Bike Pursuit', artist:'Chapter 12, Season 2'},
      {n:'S2-23', name:'TIE Fighter Assault', artist:'Chapter 12, Season 2'},
      {n:'S2-24', name:'Mando\'s big Save', artist:'Chapter 12, Season 2'},
      {n:'S2-25', name:'Good News for Moff Gideon', artist:'Chapter 12, Season 2'},
      {n:'S2-26', name:'One with the Force', artist:'Chapter 13, Season 2'},
      {n:'S2-27', name:'Ahsoka\'s Ultimatum', artist:'Chapter 13, Season 2'},
      {n:'S2-28', name:'Meeting the Jedi', artist:'Chapter 13, Season 2'},
      {n:'S2-29', name:'Trials in the Force', artist:'Chapter 13, Season 2'},
      {n:'S2-30', name:'Battle Against Beskar', artist:'Chapter 13, Season 2'},
      {n:'S2-31', name:'One Last Assault', artist:'Chapter 13, Season 2'},
      {n:'S2-32', name:'Boba\'s Brutal Assault', artist:'Chapter 14, Season 2'},
      {n:'S2-33', name:'Fennec Fires!', artist:'Chapter 14, Season 2'},
      {n:'S2-34', name:'The Legend Returns', artist:'Chapter 14, Season 2'},
      {n:'S2-35', name:'Enter the Dark Troopers', artist:'Chapter 14, Season 2'},
      {n:'S2-36', name:'The New Marshal', artist:'Chapter 14, Season 2'},
      {n:'S2-37', name:'Back with the Empire', artist:'Chapter 14, Season 2'},
      {n:'S2-38', name:'Mayfeld\'s Surprise Visitor', artist:'Chapter 15, Season 2'},
      {n:'S2-39', name:'AN UNLIKELY TEAM', artist:'Chapter 15, Season 2'},
      {n:'S2-40', name:'Saved by the…Empire?!', artist:'Chapter 15, Season 2'},
      {n:'S2-41', name:'Din Breaking in', artist:'Chapter 15, Season 2'},
      {n:'S2-42', name:'Echoes of the Past', artist:'Chapter 15, Season 2'},
      {n:'S2-43', name:'The Escape', artist:'Chapter 15, Season 2'},
      {n:'S2-44', name:'Gideon\'s Prize Force', artist:'Chapter 16, Season 2'},
      {n:'S2-45', name:'Threats of the Moff', artist:'Chapter 16, Season 2'},
      {n:'S2-46', name:'Fight to the Finish', artist:'Chapter 16, Season 2'},
      {n:'S2-47', name:'The Child\'s Connection', artist:'Chapter 16, Season 2'},
      {n:'S2-48', name:'Coming Face to Face', artist:'Chapter 16, Season 2'},
      {n:'S2-49', name:'The Jedi Revealed', artist:'Chapter 16, Season 2'},
      {n:'S2-50', name:'The Child\'s New Journey', artist:'Chapter 16, Season 2'},
    ],
  },
  {
    id: 'short-printed-base-cards',
    type: 'base',
    title: 'SHORT PRINTED BASE CARDS',
    // Short prints (1:107 packs) — no parallels of their own per Cardboard Connection.
    parallels: [],
    cards: [
      {n:'SB-1', name:'The Mandalorian Meets The Client', artist:'Chapter 1, Season 1'},
      {n:'SB-2', name:'A Bounty Like No Other', artist:'Chapter 1, Season 1'},
      {n:'SB-3', name:'Carson Teva Takes Aim', artist:'Chapter 10, Season 2'},
      {n:'SB-4', name:'The Mandalorian and Clan Kryze', artist:'Chapter 11, Season 2'},
      {n:'SB-5', name:'Class Participation', artist:'Chapter 12, Season 2'},
      {n:'SB-6', name:'Nevarro Nummies for Grogu', artist:'Chapter 12, Season 2'},
      {n:'SB-7', name:'Lang and Magistrate Morgan Elsbeth', artist:'Chapter 13, Season 2'},
      {n:'SB-8', name:'Ahsoka Tano', artist:'Chapter 13, Season 2'},
      {n:'SB-9', name:'The Return of Boba Fett', artist:'Chapter 14, Season 2'},
      {n:'SB-10', name:'Fennec Shand and The Mandalorian Back-to-Back', artist:'Chapter 14, Season 2'},
      {n:'SB-11', name:'Mando Unmasked!', artist:'Chapter 15, Season 2'},
      {n:'SB-12', name:'Migs Mayfeld Serving His Sentence', artist:'Chapter 15, Season 2'},
      {n:'SB-13', name:'A Mysterious Jedi Approaches', artist:'Chapter 16, Season 2'},
      {n:'SB-14', name:'A Clan of Two', artist:'Chapter 16, Season 2'},
      {n:'SB-15', name:'In the Mudhorn Pit', artist:'Chapter 2, Season 1'},
      {n:'SB-16', name:'Grogu in His Pram', artist:'Chapter 2, Season 1'},
      {n:'SB-17', name:'Greef Karga on Nevarro', artist:'Chapter 3, Season 1'},
      {n:'SB-18', name:'Omera Tries to Unmask The Mandalorian', artist:'Chapter 4, Season 1'},
      {n:'SB-19', name:'Peli Motto and Grogu', artist:'Chapter 5, Season 1'},
      {n:'SB-20', name:'Toro Calican Conspires with The Mandalorian', artist:'Chapter 5, Season 1'},
      {n:'SB-21', name:'Burg and Migs Mayfeld', artist:'Chapter 6, Season 1'},
      {n:'SB-22', name:'Moff Gideon and His Death Troopers', artist:'Chapter 7, Season 1'},
      {n:'SB-23', name:'Kuiil Discovers IG-11', artist:'Chapter 7, Season 1'},
      {n:'SB-24', name:'Mando Hoists the E-WEB heavy blaster cannon', artist:'Chapter 8, Season 1'},
      {n:'SB-25', name:'Cobb Vanth, the Marshal of Mos Pelgo', artist:'Chapter 9, Season 2'},
    ],
  },
  {
    id: 'illustrated-characters',
    type: 'insert',
    title: 'ILLUSTRATED CHARACTERS',
    parallels: [
      { id: 'blue-refractor', name: 'Blue Refractor', print_run: 99, color: '#2979ff' },
      { id: 'green-refractor', name: 'Green Refractor', print_run: 50, color: '#00e676' },
      { id: 'orange-refractor', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
      { id: 'red-refractor', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'superfractor', name: 'SuperFractor', print_run: 1, color: '#f0c040' },
    ],
    cards: [
      {n:'IC-1', name:'Cobb Vanth Helmet'},
      {n:'IC-2', name:'Cobb Vanth No helmet'},
      {n:'IC-3', name:'Fennec Shand'},
      {n:'IC-4', name:'Mando'},
      {n:'IC-5', name:'Boba Fett'},
      {n:'IC-6', name:'Ahsoka Tano'},
      {n:'IC-7', name:'Ahsoka Tano'},
      {n:'IC-8', name:'Ahsoka & Grogu'},
      {n:'IC-9', name:'Mando Carrying Gear'},
      {n:'IC-10', name:'Grogu Soup'},
      {n:'IC-11', name:'Grogu'},
      {n:'IC-12', name:'Bo-Katan and Crew'},
      {n:'IC-13', name:'Bo-Katan Kryze'},
      {n:'IC-14', name:'Koska Reeves'},
      {n:'IC-15', name:'Axe Woves'},
      {n:'IC-16', name:'Dark Troopers'},
      {n:'IC-17', name:'Mando Dark Saber'},
      {n:'IC-18', name:'Mando & Moff Gideon'},
      {n:'IC-19', name:'Luke Skywalker, Dark Tropper'},
      {n:'IC-20', name:'Mando, Dark Trooper'},
      {n:'IC-21', name:'Luke Skywalker, R2-D2, Grogu'},
      {n:'IC-22', name:'Luke Skywalker'},
      {n:'IC-23', name:'Fennec Shand, Boba Fett'},
      {n:'IC-24', name:'Grogu on Ship'},
      {n:'IC-25', name:'Grogu Meditating'},
    ],
  },
  {
    id: 'chrome-comic-covers',
    type: 'insert',
    title: 'CHROME COMIC COVERS',
    parallels: [
      { id: 'blue-refractor', name: 'Blue Refractor', print_run: 99, color: '#2979ff' },
      { id: 'green-refractor', name: 'Green Refractor', print_run: 50, color: '#00e676' },
      { id: 'orange-refractor', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
      { id: 'red-refractor', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'superfractor', name: 'SuperFractor', print_run: 1, color: '#f0c040' },
    ],
    cards: [
      {n:'CC-1', name:'The Mandalorian'},
      {n:'CC-2', name:'The Nite Owls'},
      {n:'CC-3', name:'Boba Fett'},
      {n:'CC-4', name:'Ahsoka Tano'},
      {n:'CC-5', name:'Grogu'},
    ],
  },
  {
    id: 'armored-and-ready',
    type: 'insert',
    title: 'ARMORED AND READY',
    parallels: [
      { id: 'blue-refractor', name: 'Blue Refractor', print_run: 99, color: '#2979ff' },
      { id: 'green-refractor', name: 'Green Refractor', print_run: 50, color: '#00e676' },
      { id: 'orange-refractor', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
      { id: 'red-refractor', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'superfractor', name: 'SuperFractor', print_run: 1, color: '#f0c040' },
    ],
    cards: [
      {n:'AR-1', name:'The Mandalorian'},
      {n:'AR-2', name:'Boba Fett'},
      {n:'AR-3', name:'The Armorer'},
      {n:'AR-4', name:'Clan Kryze'},
      {n:'AR-5', name:'Cobb Vanth'},
      {n:'AR-6', name:'Dark Trooper'},
      {n:'AR-7', name:'Paz Vizsla'},
      {n:'AR-8', name:'IG-11'},
      {n:'AR-9', name:'The Mandalorian'},
      {n:'AR-10', name:'Fennec Shand'},
    ],
  },
  {
    id: 'the-mandalorian-legends-diecut',
    type: 'insert',
    title: 'THE MANDALORIAN LEGENDS DIECUT',
    parallels: [
      { id: 'orange-refractor', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
      { id: 'red-refractor', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'superfractor', name: 'SuperFractor', print_run: 1, color: '#f0c040' },
    ],
    cards: [
      {n:'ML-1', name:'Grogu'},
      {n:'ML-2', name:'The Mandalorian'},
      {n:'ML-3', name:'Kuiil'},
      {n:'ML-4', name:'IG-11'},
      {n:'ML-5', name:'Boba Fett'},
      {n:'ML-6', name:'Greef Karga'},
      {n:'ML-7', name:'Ahsoka Tano'},
      {n:'ML-8', name:'Fennec Shand'},
      {n:'ML-9', name:'Cobb Vanth'},
      {n:'ML-10', name:'Bo-Katan Kryze'},
    ],
  },
  {
    id: 'mandalorian-autographs',
    type: 'auto',
    title: 'MANDALORIAN AUTOGRAPHS',
    // Base autographs are unnumbered (1:33 packs); ladder Blue /150 → SuperFractor.
    parallels: [
      { id: 'blue-refractor', name: 'Blue Refractor', print_run: 150, color: '#2979ff' },
      { id: 'green-refractor', name: 'Green Refractor', print_run: 99, color: '#00e676' },
      { id: 'purple-refractor', name: 'Purple Refractor', print_run: 50, color: '#b060ff' },
      { id: 'orange-refractor', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
      { id: 'red-refractor', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'superfractor', name: 'SuperFractor', print_run: 1, color: '#f0c040' },
    ],
    cards: [
      {n:'A-PP', name:'Pedro Pascal'},
      {n:'A-WH', name:'Werner Herzog'},
      {n:'A-CW', name:'Carl Weathers'},
      {n:'A-JL', name:'John Leguizamo'},
      {n:'A-RD', name:'Rosario Dawson'},
      {n:'A-NN', name:'Nick Nolte'},
      {n:'A-TAW', name:'Taika Waititi'},
      {n:'A-MNW', name:'Ming-Na Wen'},
      {n:'A-TM', name:'Temuera Morrison'},
      {n:'A-AS', name:'Amy Sedaris'},
      {n:'A-GE', name:'Giancarlo Esposito'},
      {n:'A-KS', name:'Katee Sackhoff'},
      {n:'A-ES', name:'Emily Swallow'},
      {n:'A-MW', name:'Matthew Wood'},
      {n:'A-JKC', name:'Jake Cannavale'},
      {n:'A-JJ', name:'Julia Jones'},
      {n:'A-OA', name:'Omid Abtahi'},
      {n:'A-MBJ', name:'Mark Boone Jr.'},
      {n:'A-RB', name:'Richard Brake'},
      {n:'A-MV', name:'Mercedes Varnado'},
      {n:'A-DB', name:'Dmitrious Bistrevsky'},
      {n:'A-KO', name:'Katy O\'Brian'},
      {n:'A-CB', name:'Chris Bartlett'},
      {n:'A-SK', name:'Simon Kassianides'},
      {n:'A-MR', name:'Misty Rosas'},
      {n:'A-LS', name:'Leilani SHIU'},
      {n:'A-PA', name:'Philip Alexander'},
      {n:'A-DLI', name:'Diana Lee Inosanto'},
      {n:'A-PL', name:'Paul Sun-Hyung Lee'},
      {n:'A-ISF', name:'Isla Farris'},
      {n:'A-CHB', name:'Chris Bartlett'},
      {n:'A-CBT', name:'Chris Bartlett'},
      {n:'A-WEB', name:'W. Earl Brown'},
      {n:'A-IS', name:'Isaac Singleton Jr.'},
      {n:'A-MRK', name:'Misty Rosas'},
      {n:'A-AW', name:'Alexander Wraith'},
      {n:'A-RW', name:'Ryan Watson'},
      {n:'A-BUL', name:'Bernard Bullen'},
      {n:'A-TF', name:'Tait Fletcher'},
    ],
  },
  {
    id: 'dual-autographs',
    type: 'auto',
    title: 'DUAL AUTOGRAPHS',
    // Base card is serial /25 (rule-7 unnamed slot).
    parallels: [
      { id: 'base', name: '', print_run: 25, color: '#c8d8f0' },
      { id: 'red-refractor', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'superfractor', name: 'SuperFractor', print_run: 1, color: '#f0c040' },
    ],
    cards: [
      {n:'DA-PG', name:'Pedro Pascal / Giancarlo Esposito'},
      {n:'DA-PW', name:'Pedro Pascal / Carl Weathers'},
      {n:'DA-SV', name:'Katee Sackhoff / Mercedes Varnado'},
      {n:'DA-MW', name:'Temuera Morrison / Ming-Na Wen'},
      {n:'DA-PD', name:'Pedro Pascal / Rosario Dawson'},
      {n:'DA-NW', name:'Nick Nolte / Taika Waititi'},
      {n:'DA-HA', name:'Werner Herzog / Omid Abtahi'},
      {n:'DA-EH', name:'Giancarlo Esposito / Werner Herzog'},
      {n:'DA-SP', name:'Katee Sackhoff / Pedro Pascal'},
    ],
  },
  {
    id: 'triple-autographs',
    type: 'auto',
    title: 'TRIPLE AUTOGRAPHS',
    // Base card is serial /5 (rule-7 unnamed slot).
    parallels: [
      { id: 'base', name: '', print_run: 5, color: '#c8d8f0' },
      { id: 'superfractor', name: 'SuperFractor', print_run: 1, color: '#f0c040' },
    ],
    cards: [
      {n:'TA-PWE', name:'Pedro Pascal / Carl Weathers / Giancarlo Esposito'},
      {n:'TA-SKV', name:'Katee Sackhoff / Simon Kassianides / Mercedes Varnado'},
      {n:'TA-PNW', name:'Pedro Pascal / Nick Nolte / Taika Waititi'},
      {n:'TA-MWW', name:'Temuera Morrison / Ming-Na Wen / Matthew Wood'},
    ],
  },
  {
    id: 'the-mandalorian-legends-diecut-autograph-parallel',
    type: 'auto',
    title: 'THE MANDALORIAN LEGENDS DIECUT AUTOGRAPH PARALLEL',
    // Serial numbered; print run never published by Topps/CC — left without a serial slot.
    parallels: [],
    cards: [
      {n:'MLA-1', name:'Pedro Pascal'},
      {n:'MLA-2', name:'Carl Weathers'},
      {n:'MLA-3', name:'Rosario Dawson'},
      {n:'MLA-4', name:'Nick Nolte'},
      {n:'MLA-5', name:'Taika Waititi'},
      {n:'MLA-6', name:'Ming-Na Wen'},
      {n:'MLA-7', name:'Temuera Morrison'},
      {n:'MLA-8', name:'Katee Sackhoff'},
    ],
  },
  {
    id: 'sketch-cards',
    type: 'sketch',
    title: 'SKETCH CARDS',
    // Roster never published; standard 1:117 packs, shaped 1:1,173 packs.
    parallels: [],
    cards: [
      {n:'SK-1', name:'Sketch Card', artist:'Various Artists'},
      {n:'SK-2', name:'Shaped Sketch Card', artist:'Various Artists'},
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array (or intentionally none), so
// these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
